module.exports = __webpack_public_path__ + "img/solution-building.3c30781b.jpg";